module.exports = __webpack_public_path__ + "img/img_lianghua_fuwuone@3x.5a0941f5.png";